import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const ROWS = [
  ["startup_cost","STARTUP COST"], ["difficulty","DIFFICULTY"], ["time","TIME"],
  ["interaction","INTERACTION"], ["speed_first_dollar","SPEED TO FIRST $"],
  ["income_potential","INCOME POTENTIAL"], ["scalability","SCALABILITY"],
  ["risk","RISK"], ["ai_potential","AI POTENTIAL"], ["escape_score","ESCAPE SCORE"]
];

export default function Compare() {
  const [sp] = useSearchParams();
  const ids = (sp.get("ids") || "").split(",").filter(Boolean);
  const [opps, setOpps] = useState([]);

  useEffect(() => {
    Promise.all(ids.map(id => api.get(`/opportunities/${id}`).then(r => r.data.opportunity))).then(setOpps);
  }, [sp]);

  if (opps.length === 0) return <div className="p-8 text-gray-400">Pick opportunities from the Dashboard to compare. <Link to="/dashboard" className="text-[#FD0F10]">Back</Link></div>;

  return (
    <div className="max-w-5xl mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">SIDE-BY-SIDE COMPARISON</div>
      <h1 className="font-display text-3xl font-black mt-1">Which fits you best?</h1>
      <div className="mt-6 overflow-x-auto card-panel">
        <table className="w-full text-sm" data-testid="compare-table">
          <thead>
            <tr className="border-b border-[#2A2E39]">
              <th className="text-left p-3 font-mono-ui text-[10px] uppercase tracking-wider text-gray-400">METRIC</th>
              {opps.map(o => <th key={o.id} className="text-left p-3 font-display font-bold text-white">{o.title}</th>)}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, label]) => (
              <tr key={k} className="border-b border-[#2A2E39]/50">
                <td className="p-3 font-mono-ui text-[10px] uppercase tracking-wider text-gray-400">{label}</td>
                {opps.map(o => <td key={o.id} className="p-3 text-gray-200" data-testid={`compare-${k}-${o.id}`}>{k === "escape_score" ? `${o[k]}%` : typeof o[k]==="number" ? `${o[k]}/10` : o[k]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
        <p className="mt-3 px-3 text-xs text-gray-400" data-testid="compare-earnings-disclaimer">Results depend on your effort. The more hours you put in, the faster it usually grows. Most people earn less at first, and that's normal.</p>
      </div>
    </div>
  );
}
